import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "px-1 pt-1.5 pb-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "aspect-w-16 aspect-h-9" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "px-1 pt-1.5 pb-2" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "min-w-[20rem]" }
const _hoisted_11 = { class: "aspect-w-16 aspect-h-9" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "ml-5 mt-2" }
const _hoisted_14 = { class: "text-3xl font-serif" }
const _hoisted_15 = {
  class: "font-serif px-1",
  style: {"white-space":"pre-wrap","word-wrap":"break-word"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Array.isArray(_ctx.recommend) && _ctx.recommend.length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (_ctx.store.state.base.responsive.isMD)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommend, (recommend_item) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: recommend_item.id,
                  class: "card-outlined p-4 my-2"
                }, [
                  _createElementVNode("li", _hoisted_2, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.openSalesPage(recommend_item.sales_url)),
                      class: "flex justify-center hover:opacity-75 cursor-pointer"
                    }, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            loading: "lazy",
                            src: recommend_item.thumbnail_url,
                            alt: "thumbnail",
                            class: "w-full"
                          }, null, 8, _hoisted_6)
                        ])
                      ])
                    ], 8, _hoisted_3)
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommend, (recommend_item) => {
                return (_openBlock(), _createElementBlock("ul", {
                  key: recommend_item.id,
                  class: "card-outlined py-2 px-4 my-4"
                }, [
                  _createElementVNode("li", _hoisted_8, [
                    _createElementVNode("div", {
                      onClick: ($event: any) => (_ctx.openSalesPage(recommend_item.sales_url)),
                      class: "flex items-center justify-start hover:opacity-75 cursor-pointer"
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("img", {
                            width: "100%",
                            height: "100%",
                            loading: "lazy",
                            src: recommend_item.thumbnail_url,
                            alt: "thumbnail"
                          }, null, 8, _hoisted_12)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h2", _hoisted_14, _toDisplayString(recommend_item.title), 1),
                        _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(recommend_item.body), 1)
                      ])
                    ], 8, _hoisted_9)
                  ])
                ]))
              }), 128))
            ]))
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createTextVNode(" 現在受講できる講座はありません。新しい情報をお待ちください。 ")
      ], 64))
}